import { useCallback } from "react";
import { useChatContext } from "stream-chat-react";
import { useNavigate } from "Navigation/useNavigate";
import { appUrl } from "Utils/UrlUtils";

/**
 * Opens a channel that was just created through the API: the backend only returns its id, so the
 * channel has to be watched before it can become the active one. Shared by every create entry
 * point that lives inside the Stream chat context.
 */
export const useOpenCreatedChannel = () => {
  const navigate = useNavigate();
  const { client, setActiveChannel } = useChatContext();

  return useCallback(
    (channelId: string) => {
      const channel = client.channel("messaging", channelId);
      channel
        .watch()
        .then(() => {
          setActiveChannel(channel);
          navigate(`${appUrl("chat")}/${channelId}`, { replace: true });
        })
        .catch(() => {
          // Watch can fail (permissions/network) — fall back to the list rather than
          // leaving the user on a dead view with an unhandled rejection.
          navigate(appUrl("chat"), { replace: true });
        });
    },
    [client, setActiveChannel, navigate],
  );
};
